import React, { useState, useEffect } from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
    Container,
    Grid,
    Typography,
    Box,
    TextField,
    makeStyles,
    Divider,
    useMediaQuery,
    InputAdornment,
    InputLabel
} from '@material-ui/core';
import CalInfo from './CalInfo';

const labels = ['Principal & Interest', 'Property tax', "Homeowners's insurance", 'PMI', 'HOA fees'];
const initialData = [0, 300, 100, 160, 100]; // Initial data for the doughnut chart







const useStyles = makeStyles(() => ({

    container: {
        marginTop: '20px',
    },

    bannerContainer: {
        marginTop: '100px',

    },



    textBox: {


    },

    labelMCal: {
        fontSize: '28px',
        width: '50%',
        textAlign: 'left',
        marginRight: '8px', // space between label and TextField
        marginTop: '15px',
        backgroundColor: '#FFFFFF',

    },
    labelText: {
        fontFamily: 'Inter',
        fontSize: '28px',
        fontWeight: '500',
        width: '100%',
        textAlign: 'left',
        marginRight: '8px', // space between label and TextField
        backgroundColor: 'none'
    },
    labelStart: {
        fontFamily: 'Inter',
        fontSize: '28px',
        fontFamily: 'Inter',
        width: '100%',
        textAlign: 'right',
        marginRight: '8px', // space between label and TextField
    },
    labelFinal: {
        fontFamily: 'Inter',
        fontWeight: '500',
        fontSize: '28px',
        textAlign: 'right',
        marginRight: '8px', // space between label and TextField
    },

    divider: {
        margin: '8px 0', //  divider margin
        // backgroundColor: 'black',
    },
    totalPaymentContainer: {
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid #000',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
    },

    textRight: {
        textAlign: 'right',
        fontSize: '28px',
        width: '25%', //  TextField Width
    },




    //   Mortgage Calculator


    bannerContainer: {
        marginTop: '100px',
        marginBottom: '100px',
    },

    titleCal: {

    },

    // label: {
    //   width: '75%',
    //  height: 'fit-content',
    // top: '4px',
    //gap: '5px',
    //fontFamily: 'DM Sans, sans-serif',
    //fontWeight: '400',
    //fontSize: '28px',
    //lineHeight: '18.23px',
    //marginTop: '15px',
    //marginBottom: '15px',
    //},


    inputContainerCal: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '16px',
    },
    input: {
        width: '125%',   // Mortgage Calculator Input 
        height: 'fit-content',
        paddingTop: '14px',
        paddingBottom: '14px',
        paddingLeft: '8px',
        paddingRight: '16px',
        borderRadius: '8px',
        // border: '1px solid #000',
        fontSize: '28px',
    },
    calBox: {
        //background:'none',
    }






}));










const chartData = {
    labels: labels,
    datasets: [
        {
            label: '# of Votes',
            data: initialData,
            backgroundColor: [
                'rgb(30, 144, 255)',
                'rgb(65, 105, 225)',
                'rgb(100, 149, 237)',
                'rgb(176, 196, 222)',
                'rgb(0, 0, 205)',
            ],
            borderWidth: 1,
        },
    ],
};

const options = {
    plugins: {
        legend: {
            display: false,
        },
        tooltip: {
            enabled: true,
        },
        datalabels: {
            display: true,
        },
    },
};


const MortgageCalculator = ({ onMonthlyPaymentChange }) => {
    const classes = useStyles();
    const [principal, setPrincipal] = useState('400000');
    const [downPaymentPercentage, setDownPaymentPercentage] = useState('20');
    const [interestRate, setInterestRate] = useState('7.03');
    const [loanTerm, setLoanTerm] = useState('30');
    const [propertyTax, setPropertyTax] = useState('');
    const [homeInsurance, setHomeInsurance] = useState('');
    const [pmi, setPMI] = useState('');
    const [hoaFees, setHOAFees] = useState('');
    const [monthlyPayment, setMonthlyPayment] = useState(0);

    const calculateMonthlyPayment = () => {
        const loanAmount = parseFloat(principal * (100 - downPaymentPercentage)) / 100;
        const interest = parseFloat(interestRate) / 100 / 12;
        const loanDuration = parseFloat(loanTerm) * 12;

        if (loanAmount && interest && loanDuration) {
            const monthlyRate = Math.pow(1 + interest, loanDuration);
            const monthlyPayment = (loanAmount * interest * monthlyRate) / (monthlyRate - 1);
            setMonthlyPayment(monthlyPayment.toFixed(2));
            onMonthlyPaymentChange(monthlyPayment.toFixed(2)); // Pass the monthly payment to the parent component
        } else {
            setMonthlyPayment(0);
            onMonthlyPaymentChange(0); // Pass 0 as the monthly payment to the parent component
        }
    };

    const handleChange = (event) => {
        const value = event.target.value;
        const name = event.target.name;

        // Update the corresponding state based on the input field name
        switch (name) {
            case 'principal':
                setPrincipal(value);
                break;
            case 'downPaymentPercentage':
                setDownPaymentPercentage(value);
                break;
            case 'interestRate':
                setInterestRate(value);
                break;
            case 'loanTerm':
                setLoanTerm(value);
                break;
            case 'propertyTax':
                setPropertyTax(value);
                break;
            case 'homeInsurance':
                setHomeInsurance(value);
                break;
            case 'pmi':
                setPMI(value);
                break;
            case 'hoaFees':
                setHOAFees(value);
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        calculateMonthlyPayment();
    }, [principal, interestRate, loanTerm, downPaymentPercentage]); // Trigger the calculation whenever the relevant inputs change

    const calculateTotalPayment = () => {
        const baseMonthlyPayment = parseFloat(monthlyPayment);
        const tax = parseFloat(propertyTax);
        const insurance = parseFloat(homeInsurance);
        const pmiRate = parseFloat(pmi) / 100;
        const hoa = parseFloat(hoaFees);

        const totalPayment = baseMonthlyPayment + tax / 12 + insurance / 12 + (baseMonthlyPayment * pmiRate) / 12 + hoa;
        return totalPayment.toFixed(2);
    };

    return (

        <Box marginBottom={2}>

            <Typography marginBottom={5} variant="h6" style={{ fontSize: '44px', fontFamily: 'Inter', fontWeight: 700 }}>
                Mortgage Calculator Tool
            </Typography>

            <Grid container spacing={2}  >

                <Grid item xs={12} sm={12} md={6}>


                    <InputLabel  sx={{ marginBottom: 2,  }}>Home Price</InputLabel>

                    <div>
                        <TextField
                            type="number"
                            name="principal"
                            value={principal}
                            onChange={handleChange}
                            InputProps={{
                                className: classes.input,
                                style: { border: '1px solid black' ,width:'100%'}, // Add the border style here
                            }}

                        />
                    </div>

                </Grid>
                <Grid item xs={12} sm={12} md={6}>


                    <InputLabel  sx={{ marginBottom: 2, }}>Down Payment (%):</InputLabel>

                    <div>
                        <TextField
                            type="number"
                            step="0.01"
                            name="downPaymentPercentage"
                            value={downPaymentPercentage}
                            onChange={handleChange}
                            InputProps={{
                                className: classes.input,
                                style: { border: '1px solid black',width:'100%' }, // Add the border style here
                            }}


                        />
                    </div>
                </Grid>

                <Grid item xs={12} sm={12} md={6}>

                    <InputLabel  sx={{ marginBottom: 2, }}>Loan Term (years):</InputLabel>

                    <div>
                        <TextField
                            type="number"
                            name="loanTerm"
                            value={loanTerm}
                            onChange={handleChange}
                            InputProps={{
                                className: classes.input,
                                style: { border: '1px solid black',width:'100%' }, // Add the border style here
                            }}

                        />
                    </div>

                </Grid>





                <Grid item xs={12} sm={12} md={6}>

                    <InputLabel  sx={{ marginBottom: 2 ,}}>Interest Rate (%):</InputLabel>

                    <div>
                        <TextField
                            type="number"
                            step="0.01"
                            name="interestRate"
                            value={interestRate}
                            onChange={handleChange}
                            InputProps={{
                                className: classes.input,
                                style: { border: '1px solid black',width:'100%' }, // Add the border style here
                            }}

                        />
                    </div>
                </Grid>

                <Grid item xs={12} sm={12} md={6}>

                    <InputLabel  sx={{ marginBottom: 2,}}>Zip Code</InputLabel>

                    <div>
                        <TextField
                            type="number"
                            InputProps={{
                                className: classes.input,
                                style: { border: '1px solid black',width:'100%'  }, // Add the border style here
                            }}



                        />
                    </div>

                </Grid>


            </Grid>

        </Box>





    );
};



// Define the style object
const textFieldStyle = {
    borderRadius: '4px',
    border: '1px solid #000',
    backgroundColor: '#FFFFFF',
    textAlign: 'right',
    width: '50%',
    fontSize: '28px',
    '& .adornment': {
        fontSize: '24px',
    },
};



























const ColorPalette = ({ handleChange, monthlyPayment }) => {

    const classes = useStyles();
    const [inputValues, setInputValues] = useState(initialData);

    useEffect(() => {
        const newData = [...inputValues];
        newData[0] = monthlyPayment;
        setInputValues(newData);
        handleChange(newData);
    }, [monthlyPayment]);

    const handleInputChange = (event, index) => {
        const newData = [...inputValues];
        newData[index] = parseInt(event.target.value, 10) || 0;
        setInputValues(newData);
        handleChange(newData);
    };

    function formatNumberWithCommas(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    const isMobile = window.innerWidth <= 600; // Set your desired mobile breakpoint here


    return (

        <Grid item xs={12}>
            {labels.map((label, index) => (
                <React.Fragment key={index}>
                    {/*//  Box Label,TextBox*/}
                    <Box
                        display="flex"
                        flexDirection="row" // Always align items in the same row
                        alignItems="center" // Align items vertically centered
                        marginBottom={3}
                        marginTop={3}
                    >
                        {/*// Bullet */}
                        <Box
                            className="bullet"
                            width={30}
                            height={30}
                            marginRight={5} // Add spacing between bullet and label
                            borderRadius="50%"
                            flexShrink={0}
                            bgcolor={chartData.datasets[0].backgroundColor[index]}
                        />

                        <Box marginRight={'auto'} width={400}>
                            {/*// Label */}
                            <Typography className={classes.labelText}
                                sx={{
                                    fontFamily: 'DM Sans, sans-serif',
                                    fontWeight: '400',
                                    fontSize: '40px',
                                    lineHeight: '18.23px',
                                    marginTop: '15px',
                                    marginBottom: '15px',
                                    marginLeft: index === 0 ? '0px' : 'initial', // Align Typography to the right

                                }}
                            >
                                {label}
                            </Typography>
                        </Box>

                        {index !== 0 && !isMobile && (
                            <>
                                <span style={{ fontSize: '32px', color: 'black', alignItems: 'right' }}>
                                    +&nbsp;
                                </span>
                            </>

                        )}







                        {index === 0 ? (

                            <Typography className={classes.labelStart}>
                                ${formatNumberWithCommas(inputValues[index])}
                            </Typography>

                        ) : (
                            <TextField
                                type="number"
                                value={inputValues[index]}
                                onChange={(event) => handleInputChange(event, index)}
                                variant="outlined"
                                style={{
                                    marginLeft: 'auto', // Align to the right end of the box
                                    width: '30%', // Adjust width as needed
                                }}
                                inputProps={{
                                    style: {
                                        textAlign: 'right',
                                        fontSize: 28, // Set the font size of Addition Mortgage Items
                                    },
                                    step: 1,
                                }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start" className="adornment">
                                            <Typography variant="h5">$</Typography>
                                        </InputAdornment>
                                    ),
                                }}
                            />

                        )
                        }
                    </Box>
                    {index < labels.length - 1 && <Divider className={classes.divider} />} {/* Horizontal divider */}
                </React.Fragment>
            ))}
        </Grid>



    );
};



const Cal5 = () => {


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const plugins = [{
        beforeDraw: function (chart) {
            var width = chart.width,
                height = chart.height,
                ctx = chart.ctx;
            ctx.restore();
            var fontSize = (height / 160).toFixed(2);
            ctx.font = fontSize + "em sans-serif";
            ctx.textBaseline = "top";
            var text = "Foo-bar",
                textX = Math.round((width - ctx.measureText(text).width) / 2),
                textY = height / 2;
            ctx.fillText(text, textX, textY);
            ctx.save();
        }
    }]

    const isMobile = useMediaQuery('(max-width: 600px)');

    const [chartValues, setChartValues] = useState(initialData);
    const [monthlyPayment, setMonthlyPayment] = useState(0);

    const handleMonthlyPaymentChange = (value) => {
        setMonthlyPayment(value);
    };

    const handleChartChange = (newData) => {
        setChartValues(newData);
    };

    const updatedChartData = {
        ...chartData,
        datasets: [
            {
                ...chartData.datasets[0],
                data: chartValues,
            },
        ],


    }




    const classes = useStyles();

    const boxStyles = {
        marginTop: '50px',
        textAlign: isMobile ? 'left' : 'center',
    };

    const calculateTotalMonthlyPayment = () => {
        const sum = chartValues.reduce((a, b) => a + parseFloat(b), 0);
        return (sum).toFixed(2);
    };

    function formatNumberWithCommas(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }



    const centerTitlePlugin = {
        id: 'center-title-plugin',
        beforeRender: function (chart) {
            const { width, height, ctx } = chart;
            const centerText = 'Total';
            const fontSize = 20;
            const textX = width / 2;
            const textY = height / 2;

            ctx.restore();
            ctx.font = `${fontSize}px Arial`;
            ctx.fillStyle = '#000';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(centerText, textX, textY);
            ctx.save();
        },
    };

    if (!options.plugins) {
        options.plugins = {}; // Create plugins object if it doesn't exist
    }

    if (!options.plugins.plugins) {
        options.plugins.plugins = []; // Create plugins array if it doesn't exist
    }

    options.plugins.plugins.push(centerTitlePlugin);

    return (


        <Container maxWidth="xl" className={classes.container}>
            <Grid container spacing={2}>



                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >

                    <MortgageCalculator onMonthlyPaymentChange={handleMonthlyPaymentChange} />
                </Grid >


                <Grid container spacing={2}>

                    <Grid item xs={12} md={6}>

                        <Box height="auto" className={classes.chartContainer}>
                            <div className="donutChartContainer">
                                <div className="chartCenter">
                                    <Typography variant="h6" className="chartCenterText" style={{ fontFamily: 'Inter', fontWeight: 500, }}>
                                        Total Monthly Payment
                                    </Typography>
                                    <Typography variant="h6" className="chartCenterText" style={{ fontFamily: 'Inter', fontWeight: 700, fontSize: 40, marginTop: 5 }}>
                                        <span style={{ verticalAlign: 'super', fontSize: '20px', fontWeight: 500, marginRight: '10px' }}>$</span>{formatNumberWithCommas(calculateTotalMonthlyPayment())}
                                    </Typography>
                                </div>

                                <div className="chartWrapper">
                                    <Doughnut data={updatedChartData} options={options} />
                                </div>
                            </div>
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <ColorPalette handleChange={handleChartChange} monthlyPayment={monthlyPayment} />
                        <Grid item xs={12} md={6}>
                            {/*Total Monthly Payment */}
                            <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ width: '680px' }}>
                                <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginTop: '30px' }}>
                                    <Box marginLeft={3}>
                                        <Typography variant="body2" className={classes.labelFinal} sx={{ fontSize: '28px', fontWeight: 900 }}>
                                            Total Monthly Payment
                                        </Typography>
                                    </Box>
                                    <Box sx={{ marginLeft: '30px' }}></Box>
                                    {(
                                        <span style={{ marginLeft: '10px', fontSize: '32px', color: 'black' }}>
                                            =&nbsp;
                                        </span>
                                    )}
                                </Box>
                                <Box alignItems="center" sx={boxStyles}>
                                    <Typography
                                        variant="body2"
                                        className={`${classes.labelFinal} ${classes.textRight}`}
                                        sx={{
                                            fontSize: '28px',
                                            fontWeight: 900,
                                            textAlign: isMobile ? 'left' : 'center', // Conditional textAlign
                                        }}
                                    >
                                        ${formatNumberWithCommas(calculateTotalMonthlyPayment())}&nbsp;&nbsp;&nbsp;
                                    </Typography>
                                </Box>
                            </Box>

                        </Grid>
                    </Grid>

                </Grid>


                <CalInfo />



            </Grid >
        </Container>
    );
};





export default Cal5;